var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrademateIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4494_10659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71289 23.2968C6.71289 23.6281 6.98152 23.8968 7.31289 23.8968H23.2504C23.5818 23.8968 23.8504 23.6281 23.8504 23.2968V2.57803C23.8504 1.21115 22.7423 0.103027 21.3754 0.103027H5.43789C5.10652 0.103027 4.83789 0.371656 4.83789 0.703028C4.83789 1.0344 5.10652 1.30303 5.43789 1.30303C6.14207 1.30303 6.71289 1.87387 6.71289 2.57803V23.2968ZM7.55965 1.30303H21.3754C22.0796 1.30303 22.6504 1.87387 22.6504 2.57803V22.6968H7.91289V2.57803C7.91289 2.11166 7.7839 1.67542 7.55965 1.30303Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55664 11.0155C1.55664 11.3469 1.82527 11.6155 2.15664 11.6155H7.31289C7.64426 11.6155 7.91289 11.3469 7.91289 11.0155V2.57803C7.91289 1.21115 6.80483 0.103027 5.43789 0.103027C4.07095 0.103027 2.96289 1.21115 2.96289 2.57803V9.60928C2.96289 10.0545 2.60189 10.4155 2.15664 10.4155C1.82527 10.4155 1.55664 10.6842 1.55664 11.0155ZM3.9943 10.4155C4.10271 10.1688 4.16289 9.89606 4.16289 9.60928V2.57803C4.16289 1.87387 4.73371 1.30303 5.43789 1.30303C6.14207 1.30303 6.71289 1.87387 6.71289 2.57803V10.4155H3.9943Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.150391 9.60928C0.150391 10.7173 1.04864 11.6155 2.15664 11.6155C3.26464 11.6155 4.16289 10.7173 4.16289 9.60928V3.51553C4.16289 3.18416 3.89426 2.91553 3.56289 2.91553H0.750391C0.41902 2.91553 0.150391 3.18416 0.150391 3.51553V9.60928ZM2.15664 10.4155C1.71139 10.4155 1.35039 10.0545 1.35039 9.60928V4.11553H2.96289L2.96289 9.60928C2.96289 10.0545 2.60189 10.4155 2.15664 10.4155Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 8.67178C9.52539 9.00315 9.79402 9.27178 10.1254 9.27178H20.4379C20.7693 9.27178 21.0379 9.00315 21.0379 8.67178V3.51553C21.0379 3.18416 20.7693 2.91553 20.4379 2.91553H10.1254C9.79402 2.91553 9.52539 3.18416 9.52539 3.51553V8.67178ZM10.7254 8.07178V4.11553H19.8379V8.07178H10.7254Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 17.578C9.52539 17.9094 9.79402 18.178 10.1254 18.178H15.7504C16.0818 18.178 16.3504 17.9094 16.3504 17.578C16.3504 17.2467 16.0818 16.978 15.7504 16.978H10.7254V11.4843C10.7254 11.1529 10.4568 10.8843 10.1254 10.8843C9.79402 10.8843 9.52539 11.1529 9.52539 11.4843V17.578Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5136 15.1898C12.7479 15.4241 13.1278 15.4241 13.3622 15.1898L16.6434 11.9085C16.8777 11.6742 16.8777 11.2943 16.6434 11.06C16.4091 10.8257 16.0292 10.8257 15.7949 11.06L12.5136 14.3413C12.2793 14.5756 12.2793 14.9555 12.5136 15.1898Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2191 14.428C16.5505 14.428 16.8191 14.1594 16.8191 13.828V11.4843C16.8191 11.1529 16.5505 10.8843 16.2191 10.8843H13.8754C13.544 10.8843 13.2754 11.1529 13.2754 11.4843C13.2754 11.8156 13.544 12.0843 13.8754 12.0843H15.6191V13.828C15.6191 14.1594 15.8878 14.428 16.2191 14.428Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9629 14.7655C17.9629 15.0969 18.2315 15.3655 18.5629 15.3655H20.4379C20.7693 15.3655 21.0379 15.0969 21.0379 14.7655C21.0379 14.4342 20.7693 14.1655 20.4379 14.1655H18.5629C18.2315 14.1655 17.9629 14.4342 17.9629 14.7655Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9629 17.578C17.9629 17.9094 18.2315 18.178 18.5629 18.178H20.4379C20.7693 18.178 21.0379 17.9094 21.0379 17.578C21.0379 17.2467 20.7693 16.978 20.4379 16.978H18.5629C18.2315 16.978 17.9629 17.2467 17.9629 17.578Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 20.3905C9.52539 20.7219 9.79402 20.9905 10.1254 20.9905H20.4379C20.7693 20.9905 21.0379 20.7219 21.0379 20.3905C21.0379 20.0592 20.7693 19.7905 20.4379 19.7905H10.1254C9.79402 19.7905 9.52539 20.0592 9.52539 20.3905Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4494_10659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademateIcons);
export default __webpack_public_path__ + "static/media/trademateIcons.265d2ee2d8dc9352f29cd7e4f55084b8.svg";
export { ForwardRef as ReactComponent };